import { Controller } from "@hotwired/stimulus"

// Horizontal carousel with navigation dots and auto-advance
// Usage: <div data-controller="carousel" data-carousel-interval-value="5000">
export default class extends Controller {
  static targets = ["container", "slide", "dot"]
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.currentIndex = 0
    this.updateDots()
    if (this.slideTargets.length > 1) {
      this.startAutoAdvance()
    }
  }

  disconnect() {
    this.stopAutoAdvance()
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.scrollToSlide()
    this.updateDots()
    this.restartAutoAdvance()
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.scrollToSlide()
    this.updateDots()
    this.restartAutoAdvance()
  }

  goTo(event) {
    this.currentIndex = parseInt(event.currentTarget.dataset.index)
    this.scrollToSlide()
    this.updateDots()
    this.restartAutoAdvance()
  }

  scrollToSlide() {
    const slide = this.slideTargets[this.currentIndex]
    if (slide) {
      this.containerTarget.scrollTo({
        left: slide.offsetLeft - this.containerTarget.offsetLeft,
        behavior: "smooth"
      })
    }
  }

  updateDots() {
    this.dotTargets.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add("bg-brand-dark")
        dot.classList.remove("bg-black/35")
      } else {
        dot.classList.remove("bg-brand-dark")
        dot.classList.add("bg-black/35")
      }
    })
  }

  startAutoAdvance() {
    this.autoTimer = setInterval(() => this.next(), this.intervalValue)
  }

  stopAutoAdvance() {
    if (this.autoTimer) clearInterval(this.autoTimer)
  }

  restartAutoAdvance() {
    this.stopAutoAdvance()
    this.startAutoAdvance()
  }
}
